import React from "react";
import CTASection from "../CTASection/CTASection";
import styles from "./AuthorisedServiceCentre.module.css";
import serviceCentreBg from "../../../../images/Mechatronics.jpg";

export default function AuthorisedServiceCentre() {
  return (
    <section className={styles.section} id="service-centre">
      <div className={styles.imageArea}>
        <img
          className={styles.bgImage}
          src={serviceCentreBg}
          alt="Industrial robot service"
          loading="lazy"
        />
        <div className={styles.overlay} aria-hidden="true" />
        <div className={styles.content}>
          <div className={styles.inner}>
            <span className={styles.eyebrow}>Authorised Service Centre</span>
            <h2 className={styles.title}>Authorised Service Centre</h2>
            <p className={styles.description}>
              Mitsubishi Electric FA Authorised Service Center in India
            </p>
          </div>
        </div>
      </div>
      <CTASection
        title="Learn more about Authorised Service Centre"
        description="Vertical Type, Micro Working, Horizontal Type & Ceiling Mounted Robots"
        label="Know More..."
        subLabel="about Service Centre"
        href="/authorised-service-centre"
      />
    </section>
  );
}
